module.exports = __webpack_public_path__ + "static/media/papercurve-logo-white.f799b9d9.svg";